import React, { useRef, useEffect } from "react";
import homepageData from "../../utils/data/homepage.json";

const Experience = () => {
  const { missions } = homepageData;
  const sliderRef = useRef(null);
  
  // Get first 4 missions for infinite scroll
  const displayMissions = missions.slice(0, 4);
  
  // Create infinite array by duplicating the missions
  const infiniteMissions = [...displayMissions, ...displayMissions, ...displayMissions];

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const handleScroll = () => {
      // Scroll tracking logic can be added here if needed in the future
    };

    slider.addEventListener('scroll', handleScroll);
    return () => slider.removeEventListener('scroll', handleScroll);
  }, [displayMissions.length]);

  const scrollLeft = () => {
    sliderRef.current.scrollBy({ left: -426, behavior: "smooth" }); // scroll by one item (card width + gap)
  };

  const scrollRight = () => {
    sliderRef.current.scrollBy({ left: 426, behavior: "smooth" }); // scroll by one item (card width + gap)
  };

  return (
    <div className="bg-white py-20">
      {/* Title */}
      <div className="text-center mb-12">
        <p className="text-4xl font-source-serif-4 text-[#67142D] font-semibold mx-auto w-[500px] max-w-[90%]">
        विश्व सनातन महापीठ — आत्मा से अनुभूति तक
        </p>
      </div>

      {/* Infinite Scroll Experience Cards */}
      <div className="relative flex items-center justify-center px-20 max-lg:px-4">
        {/* Left Arrow */}
        <button
          onClick={scrollLeft}
          className="lg:mx-8 max-lg:mx-4 z-10 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition duration-300"
        >
          <img
            src="/assets/left-arrow.png"
            className="w-6 h-6"
            alt="Left"
          />
        </button>

        {/* Infinite Scroll Container - 4 items visible */}
        <div
          ref={sliderRef}
          className="flex gap-8 overflow-x-hidden scroll-smooth w-full"
          style={{ width: 'calc(4 * 394px + 3 * 32px)' }} // 4 items + 3 gaps
        >
          {infiniteMissions.map((mission, index) => (
            <div
              key={`${mission.title}-${index}`}
              className="flex-shrink-0 bg-white w-[394px] rounded-xl transition-shadow duration-300 hover:shadow-lg"
            >
              <img
                src={mission.cardImage}
                alt={mission.title}
                className="w-full h-auto p-5 rounded-xl object-cover"
              />
              <p className="text-center text-[#67142D] font-source-serif-4 font-semibold pb-5 text-2xl">
                {mission.title}
              </p>
            </div>
          ))}
        </div>

        {/* Right Arrow */}
        <button
          onClick={scrollRight}
          className="lg:mx-8 max-lg:mx-4 z-10 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition duration-300"
        >
          <img
            src="/assets/right-arrow.png"
            className="w-6 h-6"
            alt="Right"
          />
        </button>
      </div>
    </div>
  );
};

export default Experience;
